<template>
  <div class="daily-sett">
    <el-card>
      <div slot="header" class="clearfix picker-box">
        <span>期权持仓明细</span>
      </div>
      <div class="filter-form">
        <el-input
          v-model="filterForm.contract"
          placeholder="请输入合约"
          style="width: 180px; margin-right: 8px;"
          clearable
          size="small"
        ></el-input>
        <el-date-picker
          v-model="filterForm.dateRange"
          type="daterange"
          range-separator="至"
          start-placeholder="开始日期"
          end-placeholder="结束日期"
          style="width: 320px; margin-right: 8px;"
          :picker-options="pickerOptions"
          size="small"
        ></el-date-picker>
        <el-button type="primary" @click="handleQuery" style="margin-right: 8px;" size="small" :loading="queryLoading">查询</el-button>
        <el-button type="success" icon="el-icon-download" @click="handleDownload" size="small" :loading="exportLoading">导出</el-button>
      </div>
      <el-table :data="tableData" style="width: 100%">
        <el-table-column prop="rq" label="日期" width="100"></el-table-column>
        <el-table-column prop="pzhy" label="品种合约" width="110"></el-table-column>
        <el-table-column prop="mmfxbz" label="买/卖" width="130"></el-table-column>
        <el-table-column prop="ccsl" label="持仓数量" width="110"></el-table-column>
        <el-table-column prop="jybzj" label="交易保证金" width="110"></el-table-column>
        <el-table-column prop="ccjj" label="持仓均价" width="110"></el-table-column>
        <el-table-column prop="zjsj" label="昨结算价" width="110"></el-table-column>
        <el-table-column prop="jjsj" label="今结算价" width="110"></el-table-column>
        <el-table-column prop="jybm" label="交易编码" width="110"></el-table-column>
        <el-table-column prop="qqlxdm" label="期权类型" width="110"></el-table-column>
        <el-table-column prop="zxj" label="执行价" width="110"></el-table-column>
        <el-table-column prop="bdhy" label="标的合约" width="110"></el-table-column>
      </el-table>
      <el-row class="toolbar">
        <el-col :span="24">
          <el-pagination
              background
              layout="prev, pager, next, sizes"
              @size-change="sizeChange"
              @current-change="getData"
              :page-sizes="[10, 20, 30, 40, 50]"
              :page-size="10"
              :total="total"
          >
          </el-pagination>
        </el-col>
      </el-row>
    </el-card>
  </div>
</template>

<script>
import {Loading, Message} from "element-ui";
import {apiAnalysisData, apiDataDownload} from "../../api/analysis";
import {mapState} from "vuex";
import { saveAs } from 'file-saver';

export default {
  name: "OptHoldTotal",
  components: {},
  data() {
    return {
      size: 10,
      page: 1,
      total: 0,
      date: "",
      tableData: [],
      value: "",
      queryLoading: false,
      exportLoading: false,
      filterForm: {
        contract: "",
        dateRange: []
      },
      pickerOptions: {
        disabledDate(time) {
          return time.getTime() > Date.now();
        },
        shortcuts: [
          {
            text: "今天",
            onClick(picker) {
              picker.$emit("pick", new Date());
            },
          },
          {
            text: "昨天",
            onClick(picker) {
              const date = new Date();
              date.setTime(date.getTime() - 3600 * 1000 * 24);
              picker.$emit("pick", date);
            },
          },
          {
            text: "一周前",
            onClick(picker) {
              const date = new Date();
              date.setTime(date.getTime() - 3600 * 1000 * 24 * 7);
              picker.$emit("pick", date);
            },
          },
        ],
      },
    };
  },
  computed: {
    ...mapState(["analysisType", "curAccountId", "dateRange"]),
    curAccountInfo() {
      return {
        analysisType: this.analysisType,
        curAccountId: this.curAccountId,
      }
    }
  },
  watch: {
    curAccountInfo: {
      immediate: true,
      handler(newVal, oldVal) {
        if(oldVal !== undefined) {
          this.getData(1);
        }
      }
    },
  },
  methods: {
    sizeChange(size) {
      this.size = size;
      this.getData(this.page);
    },
    handleQuery() {
      this.queryLoading = true;
      this.getData(1);
    },
    formatDate(date) {
      if (!date) return '';
      const d = new Date(date);
      const year = d.getFullYear();
      const month = String(d.getMonth() + 1).padStart(2, '0');
      const day = String(d.getDate()).padStart(2, '0');
      return `${year}-${month}-${day}`;
    },
    async handleDownload() {
      this.exportLoading = true;
      try {
        const params = {
          a_id: this.curAccountId.join(','),
          type: "optholddata",
          b_date: this.filterForm.dateRange && this.filterForm.dateRange.length ? this.formatDate(this.filterForm.dateRange[0]) : '',
          e_date: this.filterForm.dateRange && this.filterForm.dateRange.length ? this.formatDate(this.filterForm.dateRange[1]) : ''
        };

        const response = await apiDataDownload(params);

        const contentDisposition = response.headers['content-disposition'] || response.headers['Content-Disposition'];
        let filename = `期权持仓明细.xlsx`;

        if (contentDisposition) {
          const fileNameMatch = contentDisposition.match(/filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/);
          if (fileNameMatch && fileNameMatch[1]) {
            filename = fileNameMatch[1].replace(/['"]/g, '');
            try {
              filename = decodeURIComponent(filename);
            } catch (e) {
              // Ignore decode errors, use original filename
            }
          }
        }

        const blob = new Blob([response.data], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
        saveAs(blob, filename);
        Message.success('下载成功');
      } catch (error) {
        Message.error('下载失败，请稍后重试');
      } finally {
        this.exportLoading = false;
      }
    },
    async getData(page) {
      this.page = page;
      const params = {
        a_id: this.curAccountId.join(','),
        type: this.analysisType,
        b_date: this.filterForm.dateRange && this.filterForm.dateRange.length ? this.formatDate(this.filterForm.dateRange[0]) : '',
        e_date: this.filterForm.dateRange && this.filterForm.dateRange.length ? this.formatDate(this.filterForm.dateRange[1]) : '',
        page: this.page,
        size: this.size,
        contract: this.filterForm.contract
      }
      let loadingInstance = Loading.service({target: ".el-table"});
      let res = await apiAnalysisData('dataOptholddata', params)
      loadingInstance.close();
      this.queryLoading = false;
      if (res.data.code === 0) {
        this.total = res.data.data.total;
        let resData = [];
        if (res.data.data.list) {
          resData = JSON.parse(JSON.stringify(res.data.data.list))
          resData.forEach(item => {
            delete item.id
            delete item.account_id
            delete item.created_at
            delete item.updated_at
          })
        }

        this.tableData = resData
      }
    },
  },
  mounted() {
    this.getData(1);
  },
};
</script>

<style lang="scss">
.daily-sett {
  .custom {
    margin-top: 20px;
  }

  .picker-box {
    position: relative;

    .date-picker {
      width: 140px;
      position: absolute;
      right: -4px;
      top: -4px;

      .el-input__inner {
        width: 140px;
        height: 28px;
      }

      .el-input__icon {
        line-height: 28px;
      }
    }
  }

  .filter-form {
    padding-bottom: 10px;
    border-bottom: 1px solid #ebebeb;
    display: flex;
  }

  .el-card {
    border: 0;

    .el-card__header {
      background: #1777FF;
      color: #ffffff;
    }
  }

  .cell {
    font-size: 12px;
  }

  .toolbar {
    margin-top: 20px;

    .download-btn {
      background: #409EFF;
      border: 0;
      color: #FFF;
      float: right;
      padding: 8px 10px;

      &:hover {
        background-color: #1777FF;
      }
    }

    .el-pagination {
      float: left;
    }
  }
}
</style>
